import { App, ConfigProvider } from 'antd'
import { defaultLocale, GlobalStyles, seedToken, useConfigTheme } from 'bit-ui_component_lib-b2b'
import * as React from 'react'
import { Suspense, useMemo } from 'react'
import { useDarkModeStorage } from './api/appearance/AppearanceApi'
import { app } from './piral/piral-application'
import SentryWrapper from './sentry/SentryWrapper'

import './main.css'
import screenfull from 'screenfull'

const UserAuthentication = React.lazy(() => import('./api/user/UserAuthentication'))
const QueryContext = React.lazy(() => import('./api/query/QueryContext'))

export const Root = () => {
  const [value] = useDarkModeStorage()
  const adaptedSeedToken = useMemo(() => {
    return value
      ? {
          ...seedToken,
          token: {
            ...seedToken.token,
            colorPrimary: '#b077b9',
            colorPrimaryBg: '#644468',
            colorLink: '#b077b9',
            colorLinkHover: '#cb7bd7',
            colorTextDisabled: 'rgba(255,255,255,0.45)',
            colorTextPlaceholder: 'rgba(255,255,255,0.45)'
          },
          components: {
            Alert: {
              colorErrorBg: '#2c1618',
              colorSuccessBg: '#162312'
            },
            Button: {
              dangerShadow: 'unset',
              defaultShadow: 'unset'
            }
          }
        }
      : {
          ...seedToken,
          components: {
            Button: {
              dangerShadow: 'unset',
              defaultShadow: 'unset'
            }
          }
        }
  }, [value])
  const themeConfig = useConfigTheme(adaptedSeedToken, value)

  return (
    <ConfigProvider
      theme={themeConfig}
      locale={defaultLocale}
      getPopupContainer={() => (screenfull.element as HTMLElement) ?? document.body}
    >
      <GlobalStyles />
      <App>
        <SentryWrapper>
          <Suspense fallback={<div>Lade...</div>}>
            <UserAuthentication>
              <Suspense fallback={<div>Lade...</div>}>
                <QueryContext>{app}</QueryContext>
              </Suspense>
            </UserAuthentication>
          </Suspense>
        </SentryWrapper>
      </App>
    </ConfigProvider>
  )
}
